/* global axios */
import ApiClient from './ApiClient';

class VisionAPI extends ApiClient {
  constructor() {
    super('vision', { accountScoped: true });
  }

  // Publica a pergunta do painel Vision. A resposta volta por streaming SSE
  // (#streamUrl), não nesta resposta HTTP.
  query(payload) {
    return axios.post(`${this.url}/query`, payload);
  }

  // URL do stream SSE da resposta do turn (consumido via fetch no sseVisionTransport).
  streamUrl(sessionId) {
    return `${this.url}/stream?session_id=${encodeURIComponent(sessionId)}`;
  }

  // Modo voz (OpenAI Realtime via WebRTC): emite o client secret efêmero pro browser
  // abrir a sessão speech-to-speech direto com a OpenAI. Retorna { value, expires_at, model }.
  realtimeToken() {
    return axios.post(`${this.url}/realtime_token`);
  }
}

export default new VisionAPI();
